import React, { memo, useState } from 'react'
import {
  BlobFileTypes,
  EXTENSION_ALL_IMAGES,
  IMAGE_EXTENSIONS
} from '../../libraries/BlobFileTypes'
import {
  ButtonThemesType,
  BUTTON_STYLE_PRIMARY
} from '../../libraries/ButtonTheme'
import { getMergedClassNames, getUniqueKey } from '../../utils/HTMLutils'
import Button, { ButtonProps } from '../button/Button'
import './ButtonFileUpload.scss'
const rootClassName = 'component-button-file-upload'

interface ButtonFileUploadProps {
  label?: string
  leftIcon?: React.ReactNode
  theme?: ButtonThemesType
  allowedFileTypes?: Array<BlobFileTypes>
  multiple?: boolean
  disabled?: boolean
  value: object | object[] | Blob | Blob[] | File | File[]
  onChange: (value: File | File[] | Blob | Blob[] | object | object[]) => void
  buttonProps?: ButtonProps | object
  w100?: boolean
  //   onChange: PropTypes.func,
  //   buttonProps: PropTypes.object
}

function ButtonFileUpload(props: ButtonFileUploadProps) {
  const [id] = useState(getUniqueKey())
  const isAllowedFileType = (fileName: string) => {
    const extension = fileName.replace(/^(.)*(\..+)$/, '$2').toLowerCase()
    if (props.allowedFileTypes && props.allowedFileTypes.length) {
      if (props.allowedFileTypes.indexOf(extension) > -1) {
        return true
      } else if (
        props.allowedFileTypes.indexOf(EXTENSION_ALL_IMAGES) > -1 &&
        IMAGE_EXTENSIONS.indexOf(extension) > -1
      ) {
        return true
      } else {
        return false
      }
    }
    return true
  }

  const getButtonProps = () => {
    //     disabled={props.disabled}
    //     leftIcon={props.leftIcon}
    let p = {
      theme: props.theme,
      onClick: () => {
        const hiddenInput = document.querySelector(
          `#${id} input`
        ) as HTMLElement
        if (hiddenInput) {
          hiddenInput.click()
        }
      },
      disabled: props.disabled,
      leftIcon: props.leftIcon,
      ...props.buttonProps
    } as any
    return p
  }

  return (
    <div
      className={getMergedClassNames([rootClassName, props.w100 ? 'w100' : ''])}
      id={id}
    >
      <input
        type='file'
        accept={
          props.allowedFileTypes
            ? Array(props.allowedFileTypes).join(', ')
            : undefined
        }
        tabIndex={-1}
        onChange={(evt) => {
          const files = evt.target.files || []
          const filteredFiles = Array.from(files).filter(
            (file) =>
              !props.allowedFileTypes ||
              !props.allowedFileTypes.length ||
              isAllowedFileType(file.name)
          )
          if (props.multiple) {
            props.onChange(filteredFiles)
          } else {
            props.onChange(filteredFiles[0])
          }
          const hiddenInput = document.querySelector(
            `#${id} input`
          ) as HTMLInputElement
          if (hiddenInput) {
            hiddenInput.value = ''
          }
        }}
        multiple={props.multiple}
      />
      <Button {...getButtonProps()}>{props.label}</Button>
    </div>
  )
}

ButtonFileUpload.defaultProps = {
  label: 'Escolher arquivo',
  theme: BUTTON_STYLE_PRIMARY,
  allowedFileTypes: [],
  multiple: false,
  disabled: false,
  buttonProps: {},
  w100: false
}

export default memo(ButtonFileUpload)
